import React, { FunctionComponent } from 'react';
import Dinero from 'dinero.js';

import styled from 'styled-components';

import Typography from '@components/basics/typography';

import RefLabel from './ref-label';

interface EarningsIndicatorProps {
  className?: string;
  label: Dinero.Dinero;
  refText: string;
  textTop?: boolean;
  isVertical?: boolean;
  isTextLabel?: boolean;
}

const EarningsIndicator: FunctionComponent<EarningsIndicatorProps> = ({
  className,
  label,
  refText,
  isVertical,
  textTop,
  isTextLabel,
}) => {
  return (
    <div className={className || ''}>
      {textTop && <RefLabel label={refText} isTextLabel={isTextLabel} marginBottom />}
      <MetricHeader className={isVertical ? 'vertical' : ''}>
        <Typography customFont="medium" className={'metric-number-main'}>
          {label.toFormat()}
        </Typography>
      </MetricHeader>
      {!textTop && <RefLabel label={refText} marginBottom />}
    </div>
  );
};

export default styled(EarningsIndicator)``;

const MetricHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0px;

  &.vertical {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .metric-number-ext {
    font-size: 12px;
    font-weight: 600;
    line-height: 14.4px;
    margin-top: 8px;
  }

  .metric-number-main {
    font-size: 24px;
    font-weight: 600;
    line-height: 28.8px;
  }
`;
